import React from "react";
import Quiz from "../template/Quiz";

export default () => <Quiz />;
